export enum StatusIntegracaoBoletoEnum {
  Pendente = 1,
  Pago = 2,
  Expirado = 3,
  Cancelado = 4,
  Falha = 5,
  Registrado = 6,
  Rejeitado = 7,
}
